// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'

import styles from './ScoreCard.module.scss'

export const ScoreCard = ({
  averageLabel,
  className = undefined,
  label,
  score,
}) => (
  <Box
    align="center"
    className={cx(styles.card, {
      [className]: Boolean(className),
    })}
    direction="column"
    justify="space-between"
  >
    <Box align="center" className={styles.content} justify="space-between">
      <p className={styles.score}>{label}</p>
      <ScoreChip size="small" {...{ score }} />
    </Box>
    <p className={styles.average}>{averageLabel}</p>
  </Box>
)
